import Button from "component/ui/Button";
import { useEffect, useState } from "react";
import { Award, Landmark } from "lucide-react";
import { useNavigate } from "react-router-dom";
import chip from "../../../assets/chip-new.png";
import PageHeading from "component/ui/PageHeading";
import PageContainer from "component/ui/PageContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getBankAccountList,
  getPaymentCardsList,
  removePaymentMethod,
  setAsDefaultPaymentMethod,
} from "store/slice/booking";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "./stripe";
import AddCardForm from "./addCardForm";
import { IoClose } from "react-icons/io5";
import FullPageLoader from "component/ui/fullPageLoader";
import { MdCheckBoxOutlineBlank, MdDelete } from "react-icons/md";
import ConfirmationDialog from "component/dialogs/ConfirmationDialog";
import { getCountryCode } from "helper/appConstant";
import { useLoginData } from "component/common/loginData";

const bankAccounts = [
  { name: "Abhay Vishwakarma", number: "**** **** **** 2202" },
  { name: "Abhay Vishwakarma", number: "**** **** **** 8841" },

  { name: "Abhay Vishwakarma", number: "**** **** **** 1096" },
  { name: "Abhay Vishwakarma", number: "**** **** **** 1096" },
];

const card = [
  {
    name: "Abhay Vishwakarma",
    number: "**** **** **** 2202",
    validTill: "11/2029",
    status: "primary",
  },
  {
    name: "Abhay Vishwakarma",
    number: "**** **** **** 8841",
    validTill: "11/2029",
    status: "primary",
  },
  {
    name: "Abhay Vishwakarma",
    number: "**** **** **** 1096",
    validTill: "11/2029",
    status: "primary",
  },
];

const PaymentMethods = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAddCard, setShowAddCard] = useState(false);
  const [loader, setLoader] = useState(false);
  const [defaultLoader, SetDefaultLoader] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [account, setAccount] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const userData = useLoginData();
  useEffect(() => {
    if (userData) {
      fetchBanksList();
      fetchCardsList();
    }
  }, [userData]);
  // get country
  useEffect(() => {
    const fetchCountryCode = async () => {
      const code = await getCountryCode(userData);
      setCountryCode(code); // 👈 set value here
    };

    fetchCountryCode();
  }, [userData]);
  // get payment cards listing
  const fetchCardsList = async () => {
    dispatch(getPaymentCardsList(await getCountryCode(userData)));
  };
  // get bank listing
  const fetchBanksList = async () => {
    // get payment cards listing
    dispatch(getBankAccountList(await getCountryCode(userData), 1));
  };
  const { paymentCardsData, bankAccountsData } = useSelector(
    (state) => state.booking,
  );
  const handleViewBankAccounts = () => {
    navigate("/all-account");
  };

  const handlePaymentHistory = () => {
    navigate("/payment-history");
  };

  // navigate to add acount page
  const handleAddAccount = () => {
    navigate("/payment-methods/addAccount");
  };

  // handle set primary payment card success
  const handlePrimaryPaymentCardSuccess = (status) => {
    if (status) {
      fetchCardsList();
    }
    setLoader(false);
    SetDefaultLoader(false);
  };
  // set primary payment card
  const handlePrimaryPaymentCard = (id) => {
    SetDefaultLoader(true);
    const request = {
      language: "en",
      paymentMethodId: id,
      country: "AU",
    };
    dispatch(
      setAsDefaultPaymentMethod(request, handlePrimaryPaymentCardSuccess),
    );
  };

  // handle delete payment card
  const handleDeletePaymentCard = () => {
    setLoader(true);
    setShowConfirmationDialog(false);
    const request = {
      language: "en",
      paymentMethodId: account?.id,
      country: account?.country,
      locationCountry: "AU",
    };
    dispatch(removePaymentMethod(request, handlePrimaryPaymentCardSuccess));
  };

  console.log("bankAccountsData", bankAccountsData);
  return (
    <PageContainer>
      {loader && <FullPageLoader />}
      <div className="flex md:flex-row flex-col justify-between md:items-center md:gap-0 gap-2 mb-4 mt-2">
        <PageHeading title={" Payment Methods"} />
        <Button onClick={handlePaymentHistory}>Payment History</Button>
      </div>

      <div className="bg-white min-h-screen rounded-md p-4">
        {/*  Cards */}
        {countryCode && countryCode != "IN" && (
          <div className="mb-5">
            <div className="flex md:flex-row flex-col justify-between items-center mb-5">
              <h2 className="text-md font-medium text-gray-700 md:mb-0 mb-2">
                Credit or Debit Card
              </h2>

              <Button onClick={() => setShowAddCard(true)}>+ Add Card</Button>
              {/* add  card form */}
              {showAddCard && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                  <div
                    className="absolute inset-0 bg-black/60"
                    onClick={() => setShowAddCard(false)}
                  />

                  <div className="relative bg-white w-[90%] max-w-lg rounded-xl shadow-xl md:p-6 p-3">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-xl font-semibold">Add New Card</h3>
                      <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={() => setShowAddCard(false)}
                      >
                        <IoClose className="h-6 w-6" />
                      </button>
                    </div>
                    <Elements stripe={stripePromise}>
                      <AddCardForm
                        setLoader={setLoader}
                        loader={loader}
                        fetchCardsList={fetchCardsList}
                        setShowAddCard={setShowAddCard}
                      />
                    </Elements>
                  </div>
                </div>
              )}
            </div>
            <div className="flex gap-8 overflow-x-auto pb-3 thin-scrollbar">
              {paymentCardsData?.length > 0 ? (
                paymentCardsData?.map((account, index) => (
                  <div
                    key={index}
                    className=" md:min-w-[340px] min-w-[300px] rounded-2xl md:p-3 p-3 text-white shadow-xl 
                         bg-[#16adec] hover:shadow-2xl transition duration-300"
                  >
                    <div className="flex  justify-between mt-1">
                      <img src={chip} alt="Chip" className="w-14" />
                      <p className="font-semibold flex items-end">
                        {account?.cardBrand}
                      </p>
                    </div>
                    <div className="mt-3 flex justify-between gap-2">
                      <div>
                        <p className="tracking-[0.25em] font-semibold text-sm opacity-90 mt-2">
                          {`**** **** **** ${account?.last4}`}
                        </p>
                        <p className=" text-lg line-clamp-1 font-semibold tracking-wide">
                          {account?.cardHolderName}
                        </p>
                      </div>

                      <div>
                        <p>
                          <small className="text-xs font-semibold">
                            Valid till{" "}
                          </small>{" "}
                          <br />
                          <span className="text-sm font-semibold">
                            {account?.exp_month}/{account?.exp_year}
                          </span>
                        </p>
                      </div>
                    </div>
                    {account?.defaultCard ? (
                      <div className="w-fit mt-3">
                        <span
                          className="inline-flex items-center gap-1 font-semibold px-2 py-0.5 
                   text-[12px] border border-white rounded-full 
                   bg-red-500 whitespace-nowrap"
                        >
                          <Award size={14} />
                          Primary
                        </span>
                      </div>
                    ) : (
                      <div className="flex items-center justify-between mt-4">
                        {defaultLoader ? (
                          <div className="h-5 w-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          <div
                            className="flex items-center text-sm font-semibold cursor-pointer"
                            onClick={() =>
                              handlePrimaryPaymentCard(account?.id)
                            }
                          >
                            <MdCheckBoxOutlineBlank className="h-5 w-5 " />
                            &nbsp;
                            <p style={{ paddingTop: 0.9 }}> Set as primary</p>
                          </div>
                        )}
                        <div
                          onClick={() => {
                            setShowConfirmationDialog(true);
                            setAccount(account);
                          }}
                          className=" flex items-center text-sm font-semibold cursor-pointer"
                        >
                          <MdDelete color="red" className="h-5 w-5 " /> &nbsp;
                          <p style={{ paddingTop: 0.9 }}> Remove Card</p>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="h-40 text-gray-600 flex justify-center items-center border w-full rounded-lg">
                  You haven’t added any cards yet
                </div>
              )}
            </div>
          </div>
        )}

        {/* Bank Account */}
        <div>
          <div className="flex md:flex-row flex-col justify-between items-center mb-5">
            <h2 className="text-md font-medium text-gray-700 md:mb-0 mb-2">
              Bank Account Details
              <span className="text-sm text-gray-400 ml-2">
                (for withdrawal)
              </span>
            </h2>
            <Button onClick={handleAddAccount}>+ Add Account</Button>
          </div>
          <div className="flex gap-8 overflow-x-auto pb-3 thin-scrollbar">
            {bankAccountsData?.length > 0 ? (
              bankAccountsData?.map((account, index) => (
                <div
                  key={index}
                  className="md:min-w-[340px] min-w-[280px] rounded-2xl md:p-6 p-3 text-white shadow-xl 
                         bg-[#2bace2] hover:shadow-2xl transition duration-300"
                >
                  <div className="flex items-center ">
                    <div className="bg-white/25 p-3 rounded-xl backdrop-blur">
                      <Landmark size={30} />
                    </div>
                  </div>

                  <div className="md:mt-3 mt-6">
                    <p className="md:text-xl text-lg line-clamp-1 font-semibold tracking-wide">
                      {countryCode == "IN"
                        ? account?.contact_name
                        : account?.account_holder_name}
                    </p>
                    <p className="tracking-[0.25em] text-sm opacity-90 mt-2">
                      {countryCode == "IN"
                        ? `************${account?.bankInfo?.accountNumber?.slice(
                          -4,
                        )}`
                        : `************${account?.last4}`}
                    </p>
                  </div>

                  {/* subtle shine */}
                  <div className="absolute inset-0 rounded-2xl pointer-events-none" />
                </div>
              ))
            ) : (
              <div className="h-40 text-gray-600 flex justify-center items-center border w-full rounded-lg">
                You haven’t added any banks yet
              </div>
            )}
          </div>
          {/* <div className="mt-12 flex justify-center">
            <Button onClick={handleViewBankAccounts}>
              View All Bank Accounts
            </Button>
          </div> */}
        </div>
        {/* delete payment card dialog */}
        <ConfirmationDialog
          actionButtonName="Delete"
          onConfirm={handleDeletePaymentCard}
          closeDialog={() => {
            setShowConfirmationDialog(false);
          }}
          buttonShow={["actionButton", "Cancel"]}
          isDialogOpen={{
            open: showConfirmationDialog,
            message: `Are you sure you want to delete **** **** **** ${account?.last4} card ?`,
          }}
        />
      </div>
      {/* </div>
     </div> */}
    </PageContainer>
  );
};

export default PaymentMethods;
